import { c } from '@debbie/cortex/dist/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { searchAll } from '../search/index.js';
import SearchIcon from './Icons/Search.js';
import SearchInput from './SearchInput.js';
import Shortcut from './Shortcut.js';
const Search = (props) => {
    const inp = useRef(null);
    const lang = useSelector((s) => s.lang);
    const role = useRole();
    const selectedCreditorId = useSelector((s) => s.selectedCreditor);
    const onSelectHandler = props.onSelect
        ? props.onSelect
        : (result) => {
            if (role === 'client' && selectedCreditorId !== result.creditorId) {
                window.location.href = `${result.path}?creditorId=${result.creditorId}`;
            }
            else {
                c.redirect.redirect(result.path, {
                    replace: false,
                });
            }
        };
    if (!role) {
        return null;
    }
    const _search = (q) => searchAll(lang, role, q, {
        creditorId: props.creditorId ? props.creditorId : undefined,
        entity: props.entity,
    });
    if (props.removeWrapper) {
        return (React.createElement(SearchInput, { autofocus: props.autoFocus, inputRef: inp, searchDelay: 300, inputStyle: props.removeWrapper
                ? {}
                : {
                    borderRadius: '17.5px',
                }, onSelect: onSelectHandler, placeholder: props.placeholder ? (props.placeholder) : props.removeWrapper ? (lang.navigation.search) : (React.createElement(PositionedSpan, null,
                React.createElement(IconContainer, null,
                    React.createElement(SearchIcon, { style: { width: '1.25em', height: '1.25em' } })),
                React.createElement(SpanWithMargin, null, lang.navigation.search))), searchAll: _search }));
    }
    return (React.createElement(Wrapper, { ...props },
        React.createElement(Shortcut, { keys: ['command', 'e'], onPress: (e) => {
                e.preventDefault();
                inp?.current?.focus();
            }, style: {
                left: '10px',
                top: '7px',
            } }),
        React.createElement(SearchInput, { inputRef: inp, searchDelay: 300, inputStyle: props.removeWrapper
                ? {}
                : {
                    borderRadius: '17.5px',
                }, onSelect: onSelectHandler, placeholder: props.placeholder ? (props.placeholder) : props.removeWrapper ? (lang.navigation.search) : (React.createElement(PositionedSpan, null,
                React.createElement(IconContainer, null,
                    React.createElement(SearchIcon, { style: {
                            width: '1.25em',
                            height: '1.25em',
                            position: 'absolute',
                            right: '0',
                            top: '10px',
                        } })),
                React.createElement(SpanWithMargin, null, lang.navigation.search))), searchAll: _search })));
};
export default Search;
const Wrapper = styled.div `
  z-index: 999;
  em {
    font-style: normal;
    text-decoration: underline;
  }

  ${(props) => props.removeWrapper
    ? ``
    : `
          display: inline-block;
          max-width: 550px;
          width: calc(100% - 320px);
          margin-top: -3px;
          z-index: 99999;

          input {
            box-shadow: none;
            border: none;
            padding: 17px 15px 3px 15px;
            font-size: 0.8em;
          }

          .inp-placeholder {
            top: 10px;
          }
`};
`;
const PositionedSpan = styled.span `
  position: relative;
`;
const IconContainer = styled.span `
  height: 16px;
  width: 16px;
  position: absolute;
  top: -10px;
`;
const SpanWithMargin = styled.span `
  margin-left: 2em;
`;
//# sourceMappingURL=Search.js.map